import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-bottom-doodle.svg';
import spriteFlag from '~/assets/img/footer/sprite-flag.png';
var market = {
  FR: 'market-FR',
  BE: 'market-BE',
  DE: 'market-DE',
  ES: 'market-ES',
  IT: 'market-IT',
  LU: 'market-LU',
  NL: 'market-NL',
  AT: 'market-AT',
  PT: 'market-PT',
  CH: 'market-CH',
  UK: 'market-UK'
};
export default {
  name: 'Language',

  data() {
    return {
      isOpen: true,
      spriteFlag
    };
  },

  computed: _objectSpread(_objectSpread({}, mapGetters({
    currentLocale: 'i18n/locale',
    locales: 'i18n/locales'
  })), {}, {
    position() {
      return this.isOpen ? 'haut' : 'bas';
    },

    otherLocales() {
      return this.locales.filter(l => l.market !== this.currentLocale.market || l.language !== this.currentLocale.language);
    },

    marketLanguage() {
      return market[this.currentLocale.market];
    }

  }),

  mounted() {
    this.isOpen = false;
  },

  methods: {
    changeLocale(locale) {
      if (locale.market === 'US') {
        return 'https://us.maisonsdumonde.com/';
      }

      return "/".concat(locale.market, "/").concat(locale.language);
    }

  }
};